$(document).ready(function(){
  if ($(window).width() < 577) {
if (navigator.userAgent.search("Safari") >= 0 && navigator.userAgent.search("Chrome") < 0) 
{

  var _arrays = [];
 $(".product-grid li").each(function(index, el) {
 var text = $(this).find(".card-prod-title").height();
   
   _arrays.push(text);
 });
   var resultans=Math.max.apply(Math,_arrays) +6;
    $("ul.product-grid li.grid__item .card-prod-title").css("min-height",resultans+"px");    
}
    
  
    
  
  }
  
   $.fn.toHtml=function(){
   return $(this).html($(this).text())
}
$('.accordion span.metafield-multi_line_text_field').each(function(){
$(this).toHtml();
  });
  if ($(window).width() < 1024) {
    
  $("ul.list-menu.list-menu--inline details summary").click(function(event){
    event.preventDefault()
    var redirect= $(this).find("a").attr("href");
    
    window.location.replace(redirect);
  });
  }
$( "nav.header__inline-menu summary" ).hover(
  function() {
    $( this ).attr("aria-expanded","true");
    $(this).parent("details").attr("open","");
  }, function() {
    $( this ).attr("aria-expanded","false");
    
    $(this).parent("details").removeAttr("open","")
  }
   ); 
  $( "nav.header__inline-menu details .global-settings-popup" ).hover(
  function() {
    console.log("asas");
    $( this ).siblings("summary").attr("aria-expanded","true");
    $(this).parent("details").attr("open","");
  }, function() {
     $( this ).siblings("summary").attr("aria-expanded","false");
    
    $(this).parent("details").removeAttr("open","")
  }
   ); 
  // $(".product__description").addClass("opendesc");
  $("#readmoreless").click(function(){
    $(".detail-metafield .product__description-meta.small-desc-meta").toggleClass("show-me-desc-meta");
    $(".detail-metafield .product__description-meta.all-desc-meta").toggleClass("show-me-desc-meta");
    if($(".detail-metafield .product__description-meta.small-desc-meta").hasClass("show-me-desc-meta")){
    $(this).text("Read More");

    }
    else{
        $(this).text("Read Less");
   
      
    }
  });
//     setTimeout(function() {
//  $(".quick-add__submit.button").each(function(){
//       $(this).find("span").text("Warenkorb");
// })
//     },1000);
  if ($(window).width() < 750) {
  $('.product__media-list.contains-media').slick({
   
  arrows: false,
   slidesToShow: 1,
  slidesToScroll: 1,
    dots:true,
   infinite:true,
    // centerMode:true,
  
 
  
  // responsive: [
  //   {
  //     breakpoint: 481,
  //     settings: {
  //  slidesToShow: 1.2,
   
  //     }
  //   },
    
   
  //   ]
}); 
  }
//       setTimeout(function() {
//    $('h2').click(function() {
//      var liwidth= $('ul.product-grid li').outerWidth( true ) +"px";
//      console.log(liwidth);
//   event.preventDefault();
//   $('ul.product-grid').animate({
//    scrollLeft: "+="+liwidth
//   }, "slow");
// });
//       },2000);



                  });

$(document).ready(function(){

  $('.product__media-item').on('click', function() {
  //    alert('test-1');
  // clickedIndex = $('.product__media-item').not(".slick-cloned").index(this);
  //   $('.product-media-modal').attr('open', '');

});
    });

